import styled from "styled-components"

const Title = styled.h1`
  color: #fff;
  font-size: 58px;
  font-family: "din-condensed";
  font-weight: 400;
  text-transform: uppercase;
  margin: 0.75rem 0;
  pointer-events: none;
`

export default Title



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/Title.js